import { treeApi } from './treeAuth';

// Colours / Stock
export const getColours = () => treeApi.get('/colours');
export const createColour = (data) => treeApi.post('/colours', data);
export const updateColour = (id, data) => treeApi.put(`/colours/${id}`, data);
export const deleteColour = (id) => treeApi.delete(`/colours/${id}`);
export const adjustStock = (data) => treeApi.post('/stock/adjust', data);
export const getStockMovements = (params) => treeApi.get('/stock/movements', { params });
export const deleteStockMovement = (id) => treeApi.delete(`/stock/movements/${id}`);
export const checkStock = () => treeApi.get('/stock/check');
export const getTotalCollected = () => treeApi.get('/stock/total-collected');

// Field Collections
export const getFieldCollections = () => treeApi.get('/field-collections');
export const deleteFieldCollection = (id) => treeApi.delete(`/field-collections/${id}`);
export const createFieldCollection = (data) => treeApi.post('/field-collections', data);

// Field Status (Ready for Collection)
export const getFieldStatus = () => treeApi.get('/field-status');
export const updateFieldStatus = (data) => treeApi.put('/field-status', data);

// Haulers
export const getHaulers = () => treeApi.get('/haulers');
export const createHauler = (data) => treeApi.post('/haulers', data);
export const deleteHauler = (id) => treeApi.delete(`/haulers/${id}`);

// Yard Locations
export const getYardLocations = () => treeApi.get('/yard-locations');
export const createYardLocation = (data) => treeApi.post('/yard-locations', data);
export const deleteYardLocation = (id) => treeApi.delete(`/yard-locations/${id}`);

// Lorries (not routed to a page yet, kept for API parity)
export const getLorries = () => treeApi.get('/lorries');

// Loads
export const getLoads = (params) => treeApi.get('/loads', { params });
export const createLoad = (data) => treeApi.post('/loads', data);
export const getLoad = (id) => treeApi.get(`/loads/${id}`);
export const updateLoad = (id, data) => treeApi.put(`/loads/${id}`, data);
export const deleteLoad = (id) => treeApi.delete(`/loads/${id}`);
export const signManifest = (loadId, data) => treeApi.post(`/loads/${loadId}/sign`, data);
export const getManifestPublic = (loadId) => treeApi.get(`/loads/${loadId}/manifest-public`);

// Dashboard
export const getDashboardStats = () => treeApi.get('/dashboard/stats');
export const getDashboardAnalytics = () => treeApi.get('/dashboard/analytics');
export const getTvDashboardData = () => treeApi.get('/tv-dashboard-data');

// Users (admin only)
export const getTreeUsers = () => treeApi.get('/users');
export const createTreeUser = (data) => treeApi.post('/users', data);
export const updateTreeUser = (id, data) => treeApi.patch(`/users/${id}`, data);
export const deleteTreeUser = (id) => treeApi.delete(`/users/${id}`);

// Settings
export const getTreeSettings = () => treeApi.get('/settings');
export const updateTreeSettings = (data) => treeApi.put('/settings', data);

// Roles & permissions (admin only, except schema + mine)
export const getPermissionSchema = () => treeApi.get('/roles/schema');
export const getMyPermissions = () => treeApi.get('/roles/mine');
export const getRoles = () => treeApi.get('/roles');
export const createRole = (data) => treeApi.post('/roles', data);
export const updateRole = (key, data) => treeApi.patch(`/roles/${key}`, data);
export const deleteRole = (key) => treeApi.delete(`/roles/${key}`);

// Face ID / Touch ID passkeys
export const listPasskeys = () => treeApi.get('/auth/passkeys');
export const getPasskeyRegistrationOptions = () => treeApi.post('/auth/passkeys/registration/options');
export const verifyPasskeyRegistration = (credential) => treeApi.post('/auth/passkeys/registration/verify', credential);
export const deletePasskey = (credentialId) => treeApi.delete(`/auth/passkeys/${credentialId}`);
export const getPasskeyAuthenticationOptions = () => treeApi.post('/auth/passkeys/authentication/options');
export const verifyPasskeyAuthentication = (credential) => treeApi.post('/auth/passkeys/authentication/verify', credential);
